
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M53.38 11.33h43.24l25.99 67.82H27.39l25.99-67.82zM75 124.03V79.15M53 124h45.11a12.79 12.79 0 0112.79 12.79v1.85H40.16v-1.85A12.79 12.79 0 0153 124zM51.87 79.15v10.24"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"51.87","cy":"95.25","r":"6.34"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M75.53 21.58h25.02M75.53 30.85h28.57M75.53 40.6h32.31M75.53 50.36h35.37M75.53 59.63h39.6M75.53 68.9h43.16"}})])
          )
        }
      }
    